import { render } from "./esco-modulos-marketplace.vue?vue&type=template&id=d2fd1a3a&scoped=true"
import script from "./esco-modulos-marketplace.vue?vue&type=script&lang=js"
export * from "./esco-modulos-marketplace.vue?vue&type=script&lang=js"

import "./esco-modulos-marketplace.vue?vue&type=style&index=0&id=d2fd1a3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2fd1a3a"]])

export default __exports__